<template>
  <div id="template-management" class="h-full">
    <el-row :gutter="10" class="h-full">
      <el-col :span="12" class="h-full">
        <el-card class="h-full !pt-0">
          <div class="flex items-center mb-18px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">方案管理</span>
          </div>
          <!-- input输入框部分 -->
          <div class="head mb-20px">
            <el-input
              v-model="programmeForm.keyword"
              class="mr-10px"
              placeholder="请输入编码或名称"
              clearable
            ></el-input>
            <!-- button按钮部分 -->
            <el-button type="primary" @click="handleProgrammeSearch" :disabled="!$hasAccess('read')"
              >搜索</el-button
            >
            <el-button @click="resetProgrammeForm">重置</el-button>
            <el-button
              type="primary"
              @click="programmeOperate('create')"
              :disabled="!$hasAccess('create')"
              >新增</el-button
            >
            <el-button type="danger" @click="programmeBatchDetele" :disabled="!$hasAccess('delete')"
              >删除</el-button
            >
          </div>
          <!-- 列表 -->
          <div class="h-[calc(100%-151px)]">
            <el-table
              ref="programmeTable"
              :data="programmeTableData"
              v-loading="programmeLoading"
              @selection-change="programmeSelectionChange"
              @row-click="tableRowClick"
              row-key="id"
              border
              height="100%"
              stripe
              highlight-current-row
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column type="index" label="序号" width="70"></el-table-column>
              <el-table-column
                prop="code"
                label="方案编码"
                width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="name" label="方案名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="状态" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <span @click.stop>
                    <el-switch @change="openCurrentRow(row, $event)" :value="row.isEnable">
                    </el-switch>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="270px">
                <template slot-scope="{ row }">
                  <el-button
                    @click.stop="sencePreview(row)"
                    size="mini"
                    :disabled="!$hasAccess('read')"
                    >预览</el-button
                  >
                  <el-button
                    @click.stop="programmeOperate('read', row)"
                    size="mini"
                    :disabled="!$hasAccess('read')"
                    >查看</el-button
                  >
                  <el-button
                    @click.stop="programmeOperate('update', row)"
                    size="mini"
                    :disabled="!$hasAccess('update')"
                    >编辑</el-button
                  >
                  <el-button
                    @click.stop="programmeDelete(row)"
                    size="mini"
                    :disabled="!$hasAccess('delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mt-20px flex justify-end">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="getTemplateList"
              :current-page.sync="programmePage.pageNo"
              :page-sizes="pageSizeAll"
              :page-size.sync="programmePage.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="programmePage.total"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" class="h-full">
        <el-card class="h-full !pt-0">
          <div class="flex items-center mb-18px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">板块管理</span>
          </div>
          <!-- input输入框部分 -->
          <div class="head mb-20px">
            <div class="mb-10px" v-show="isRightExpand">
              <el-input
                v-model="templateName"
                class="mr-10px"
                placeholder="板块名称"
                clearable
              ></el-input>
              <el-select v-model="position" class="mr-10px" placeholder="位置" filterable clearable>
                <el-option
                  v-for="item in positionList"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </div>
            <span
              class="mr-10px text-14px text-$sidebarSelectText cursor-pointer"
              @click="changeSearchExpand"
            >
              {{ isRightExpand ? '收缩' : '展开'
              }}<i
                :class="[
                  isRightExpand ? 'el-icon-arrow-up' : 'el-icon-arrow-down',
                  'el-icon--right',
                ]"
              ></i>
            </span>
            <!-- button按钮部分 -->
            <el-button type="primary" @click="handleTemplateSearch" :disabled="!$hasAccess('read')"
              >搜索</el-button
            >
            <el-button @click="reset">重置</el-button>
            <el-button type="primary" @click="operate('create')" :disabled="!$hasAccess('create')"
              >新增</el-button
            >
            <el-button type="danger" @click="batchDetele" :disabled="!$hasAccess('delete')"
              >删除</el-button
            >
            <el-button @click="startImportTemplate" :disabled="!$hasAccess('import')"
              >导入</el-button
            >
            <el-button @click="startExportTemplate" :disabled="!$hasAccess('export')"
              >导出</el-button
            >
            <el-button @click="configVisible = true" :disabled="!$hasAccess('update')"
              >全局配置</el-button
            >
          </div>
          <!-- 列表 -->
          <div :class="isRightExpand ? 'h-[calc(100%-197px)]' : 'h-[calc(100%-151px)]'">
            <el-table
              ref="templateRef"
              :data="tableData"
              v-loading="templateLoading"
              row-key="id"
              border
              height="100%"
              stripe
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column type="index" label="序号" width="70"></el-table-column>
              <el-table-column
                prop="name"
                label="板块名称"
                width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column label="位置">
                <template slot-scope="{ row }">{{
                  row.extraDto.functionLocationTypeDesc
                }}</template>
              </el-table-column>
              <el-table-column label="业务功能" min-width="120px" show-overflow-tooltip>
                <template slot-scope="{ row }">{{ row.extraDto.businessFunctionNames }}</template>
              </el-table-column>
              <el-table-column label="基础功能" min-width="120px" show-overflow-tooltip>
                <template slot-scope="{ row }">{{ row.extraDto.basicFunctionNames }}</template>
              </el-table-column>
              <el-table-column label="标签" min-width="120px" show-overflow-tooltip>
                <template slot-scope="{ row }">{{ row.extraDto.lableNames }}</template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="200px">
                <template slot-scope="{ row }">
                  <el-button
                    @click="operate('read', row)"
                    size="mini"
                    :disabled="!$hasAccess('read')"
                    >查看</el-button
                  >
                  <el-button
                    @click="operate('update', row)"
                    size="mini"
                    :disabled="!$hasAccess('update')"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteTemplate(row)"
                    size="mini"
                    :disabled="!$hasAccess('delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mt-20px flex justify-end">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="getTemplateList"
              :current-page.sync="page.pageNo"
              :page-sizes="pageSizeAll"
              :page-size.sync="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <wiz-upload-file
      v-dialogDrag
      v-if="showUploadExcelDialog"
      @refreshList="handleTemplateSearch"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      :uploadFileProps="uploadFileProps"
    ></wiz-upload-file>
    <programme-dialog
      v-if="programmeInfo.visible"
      :programmeInfo.sync="programmeInfo"
      @updateList="updateList"
    ></programme-dialog>
    <global-config :visible.sync="configVisible"></global-config>
    <add-template
      v-if="createVisible"
      :sceneOptions="sceneList"
      :cockpitOptions="cockpitList"
      :visible.sync="createVisible"
      :positionList="positionList"
      :operateProps="operateProps"
      :operateType="operateType"
      :schemeId="currentSchemeId"
      @refresh="getTemplateList"
    ></add-template>
  </div>
</template>

<script>
import { SectionApi, SchemeApi, CockpitApi } from '@wiz-api/cloud-render-management'
import { ModelSceneApi } from '@wiz-api/scene-management'
import FnMixins from '@/assets/js/fnMixins'

const modelSceneApi = new ModelSceneApi()
const sectionApi = new SectionApi()
const schemeApi = new SchemeApi()
const cockpitApi = new CockpitApi()

// 方案管理业务组件
const ProgrammeDialog = () => {
  return import('../components/TemplateManagement/ProgrammeDialog')
}

const GlobalConfig = () => {
  return import('../components/TemplateManagement/GlobalConfig')
}

const AddTemplate = () => {
  return import('../components/TemplateManagement/AddTemplate')
}

export default {
  components: {
    ProgrammeDialog,
    GlobalConfig,
    AddTemplate,
  },
  mixins: [FnMixins],
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    config() {
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["cloud-render-management"].config'
      )
    },
  },
  data() {
    return {
      // 导入
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
      },
      // 导入组件显隐
      showUploadExcelDialog: false,
      // 方案管理搜索表单
      programmeForm: {
        keyword: '',
      },
      // 搜索列表是否展开
      isRightExpand: false,
      // 方案管理弹框信息
      programmeInfo: {
        operateType: '新增',
        visible: false,
        formData: {},
      },
      // 方案分页
      programmePage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      // 方案选择数据
      programmeSelectIds: [],
      // 表格数据
      programmeTableData: [],
      // 方案列表加载状态
      programmeLoading: false,
      // 当前选中方案id
      currentSchemeId: '',
      templateName: '',
      position: '',
      positionList: [
        {
          value: 1,
          label: '左1',
        },
        {
          value: 2,
          label: '左2',
        },
        {
          value: 3,
          label: '左3',
        },
        {
          value: 4,
          label: '左4',
        },
        {
          value: 5,
          label: '总览',
        },
        {
          value: 6,
          label: '右1',
        },
        {
          value: 7,
          label: '右2',
        },
        {
          value: 8,
          label: '右3',
        },
        {
          value: 9,
          label: '右4',
        },
      ],
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      templateLoading: false,
      selectIds: [],
      pageSizeAll: [15, 30, 45, 60, 75, 90],
      configVisible: false,
      createVisible: false,
      operateType: 'create',
      operateProps: {},
      sceneList: [],
      cockpitList: [],
    }
  },
  async created() {
    await this.handleProgrammeSearch()
    this.getSceneList()
    this.getCockpitList()
  },
  activated() {
    this.$refs.programmeTable.doLayout()
  },
  methods: {
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        name: '',
        folderId: '',
        maxResultCount: 999,
        skipCount: 0,
      })
      if (!err) {
        this.sceneList = res.items
      }
    },
    async getCockpitList() {
      const [err, res] = await cockpitApi.getList({
        code: '',
        name: '',
        sorting: 'seqNo',
        maxResultCount: 999,
        skipCount: 0,
      })
      if (!err) {
        this.cockpitList = res.items
      }
    },
    // 表单新建、编辑获取数据逻辑
    updateList(type) {
      if (type === 'edit') {
        this.getProgrammeList()
        return
      }
      this.resetProgrammeForm()
    },
    // 板块导出
    async startExportTemplate() {
      if (!this.currentSchemeId) {
        this.$message.warning('请先点击左侧列表项目选择方案')
        return
      }
      const body = _.omit(
        {
          schemeId: this.currentSchemeId,
          name: this.templateName,
          functionLocationType: this.position,
          ids: [...this.selectIds],
        },
        // 条件导出 或者 框选导出
        _.isEmpty(this.selectIds)
          ? ['ids']
          : ['schemeId', 'name', 'functionLocationType', 'parentId']
      )
      const [err, res] = await sectionApi.exportSections({
        // 过滤除 0 外的空字段
        body: _.omitBy(body, (e) => {
          return _.isNil(e) || _.eq(e, '')
        }),
        returnType: 'Blob',
      })
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '三维板块.xlsx',
          data: res,
        })
        this.$refs.templateRef.clearSelection()
        this.$message.success('导出成功')
      }
    },
    // 板块导入弹框加载
    startImportTemplate() {
      this.uploadFileProps.visible = true
      this.showUploadExcelDialog = true
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await sectionApi.downloadImportTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: '板块导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await sectionApi.callImport({
        file: formData.get('file'),
      })
      if (!err) {
        this.uploadFileProps.active = 3
        this.$message.success(this.$t('theImportToExcelIsSuccessful'))
      }
      this.uploadFileProps.btnLoading = false
    },
    // 开启当前方案
    async openCurrentRow(row, isEnable) {
      // 关闭操作，无需查询已存在开启方案
      if (isEnable) {
        // // 关闭当前方案后，开启当前操作方案
        await this.closeCureentProgramme()
      }
      await this.changeOpenStatus(row, isEnable)
      this.getProgrammeList()
    },
    // 关闭当前方案
    async closeCureentProgramme() {
      const [err, res] = await schemeApi.getList({
        isEnable: true,
        maxResultCount: 1,
        skipCount: 0,
      })
      if (!err && res) {
        const currentProgramme = _.head(res.items)
        if (!_.isEmpty(currentProgramme)) {
          await this.changeOpenStatus(currentProgramme, false)
        }
        return Promise.resolve('')
      }
      return Promise.reject(new Error('fail'))
    },
    // 是否显示名称切换
    async changeOpenStatus(data, isEnable) {
      // 兼容页面加载方式
      const params = _.clone(data)
      const [err, res] = await schemeApi.update(params.id, {
        body: { ...params, isEnable },
      })
      if (!err) {
        return Promise.resolve('')
      }
      return Promise.reject(new Error('fail'))
    },
    // 搜索栏展开收缩切换
    changeSearchExpand() {
      this.isRightExpand = !this.isRightExpand
    },
    // 重置表单数据
    resetProgrammeForm() {
      this.programmeForm = this.$options.data().programmeForm
      this.handleProgrammeSearch()
    },
    // 表单搜索
    handleProgrammeSearch() {
      this.programmePage.pageNo = 1
      this.getProgrammeList()
    },
    // 获取方案管理列表
    async getProgrammeList() {
      this.programmeLoading = true
      const [err, res] = await schemeApi.getList({
        keyword: this.programmeForm.keyword,
        maxResultCount: this.programmePage.pageSize,
        skipCount: (this.programmePage.pageNo - 1) * this.programmePage.pageSize,
      })
      this.programmeLoading = false
      if (!err && res) {
        this.programmeTableData = res.items
        this.programmePage.total = res.totalCount
      }
    },
    // 操作
    programmeOperate(type, row) {
      this.programmeInfo = _.assign(this.programmeInfo, {
        operateType: type,
        visible: true,
        formData: _.includes(['update', 'read'], type) ? _.cloneDeep(row) : {},
      })
    },
    // 方案预览
    sencePreview(row) {
      if (this.config?.visualizationCockpitPath) {
        this.$router.push(
          `${this.basePath}${this.config.visualizationCockpitPath}?schemeId=${row.id}&logo=${row.logo}`
        )
        return
      }
      this.$router.push(
        `${this.basePath}/visualization-cockpit/index?schemeId=${row.id}&logo=${row.logo}`
      )
    },
    // 方案列表框选
    programmeSelectionChange(val) {
      this.programmeSelectIds = _.map(val, (item) => {
        return item.id
      })
    },
    // 批量删除方案
    async programmeBatchDetele() {
      if (!this.programmeSelectIds.length) {
        this.$message({
          showClose: true,
          message: '请勾选要删除的方案',
          type: 'warning',
        })
        return
      }
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        if (_.includes(this.programmeSelectIds, this.currentSchemeId)) {
          this.currentSchemeId = ''
        }
        const [err, res] = await schemeApi.deleteMany({
          ids: this.programmeSelectIds,
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getProgrammeList()
        }
      })
    },
    // 单个删除方案
    programmeDelete(row) {
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await schemeApi.callDelete(row.id)
        if (!err) {
          if (_.eq(row.id, this.currentSchemeId)) {
            this.currentSchemeId = ''
          }
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getProgrammeList()
        }
      })
    },
    // 表格行点击事件, 更新右侧板块
    tableRowClick(row) {
      if (!row.id) {
        this.$message.error('当前数据异常')
        return
      }
      this.currentSchemeId = row.id
      this.reset()
    },
    // 获取板块数据
    async getTemplateList() {
      if (!this.currentSchemeId) {
        this.$message.warning('请先点击左侧列表项目选择方案')
        return
      }
      this.templateLoading = true
      const [err, res] = await sectionApi.getList({
        schemeId: this.currentSchemeId,
        name: this.templateName,
        functionLocationType: this.position,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      this.templateLoading = false
      if (!err && res) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    // 板块数据重置
    handleTemplateSearch() {
      this.page.total = 1
      this.getTemplateList()
    },
    // 重置表单数据
    reset() {
      this.templateName = ''
      this.position = ''
      this.handleTemplateSearch()
    },
    // 操作
    operate(type, row) {
      if (!this.currentSchemeId) {
        this.$message.warning('请先点击左侧列表项目选择方案')
        return
      }
      this.operateType = type
      this.createVisible = true
      switch (type) {
        case 'create':
          this.operateProps = {}
          break
        case 'update':
          this.operateProps = row
          break
        case 'read':
          this.operateProps = row
          break
        default:
          break
      }
    },
    // 批量删除
    async batchDetele() {
      if (!this.selectIds.length) {
        this.$message({
          showClose: true,
          message: '请勾选要删除的模块',
          type: 'warning',
        })
        return
      }
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await sectionApi.deleteMany({
          ids: this.selectIds,
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getTemplateList()
        }
      })
    },
    deleteTemplate(row) {
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await sectionApi.callDelete(row.id)
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getTemplateList()
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.getTemplateList()
    },
    handleSelectionChange(val) {
      this.selectIds = _.map(val, (item) => {
        return item.id
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#template-management {
  * {
    transform: all 0.5s;
  }
  .head {
    ::v-deep .el-input {
      width: 200px;
    }
  }
  ::v-deep {
    .el-card__body {
      height: 100%;
    }
    .el-table__row {
      cursor: pointer;
    }
  }
}
</style>
